<template>
  <div>
    <div class="w-ext-login-header">
      <img rel="preload" src="~@/assets/images/logo_scmgroup.svg" alt="Scm Group" class="w-logo" />
    </div>
    <div class="w-ext-login-body">
      <div class="oval">
        <img rel="preload" src="~@/assets/images/user.png" alt="User" />
      </div>
      <a class="btn-block btn-iot btn-login" :disabled="disableLogin" :href="externalLoginUrl">
        {{ $t("login.sso_external_credientials") }}
        <i class="fas fa-spinner fa-spin spin-off" :class="{ active: spinOff }" />
      </a>
    </div>
    <div class="w-ext-login-footer">
      <img rel="preload" src="~@/assets/images/home-ind-scm.svg" alt="Scm" />
      <img rel="preload" src="~@/assets/images/home-ind-cms.svg" alt="Cms" />
    </div>
  </div>
</template>

<script>
import { externalAuthenticationProviderUrl } from "@/common/config";
export default {
  name: "LoginExternal",
  data() {
    return {
      input: {},
      spinOff: true,
      externalLoginUrl: ""
    };
  },
  computed: {
    disableLogin() {
      return !this.spinOff;
    }
  },
  mounted() {
    // Clear all local storage
    localStorage.clear();
  },
  created() {
    this.externalLoginUrl = `${externalAuthenticationProviderUrl}sso?redirect_uri=${encodeURIComponent(
      window.location.origin + "/external-login-callback"
    )}`;
  }
};
</script>
<style scoped lang="scss">
.w-logo {
  max-height: 50px;
}
.w-ext-login-body {
  padding-top: 16%;
  padding-bottom: 16%;
}
.btn-login {
  width: 220px;
  line-height: 36px;
  margin: 25px auto;
}
.btn-login:hover {
  text-decoration: none;
  color: #002e6e;
}
.oval {
  margin: 15px auto;
}
</style>
